export default __webpack_public_path__ + "src/_images/HandingKeys_Stretch.png";